import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DesktopMenu from "../../common/DesktopMenu/index";
import MobileMenu from "../../common/MobileMenu/index";
import useWindowSize from "../../common/windowSize";
import NewFooter from "../../common/NewFooter";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useLocation } from 'react-router-dom';
import { publicAPI } from "../../utils/api";
import {
  Background,
  AllProductsTitle,
  CreamTitle,
  AllProductsWrapper,
  TittleWrapper,
  FilterButton,
  FilterButtonWrapper,
  CategoryButtonWrapper
} from "./styles";
import {
  Text
} from "../../common/Header/styles";
import Grid from "@mui/material/Grid";
import SingleProduct from "./Product";
import BackButton from "./BackButton";
import { useTranslation } from "react-i18next";

const Products = () => {
  const { id } = useParams();
  const size = useWindowSize();
  const location = useLocation();
  const { t } = useTranslation();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [groupName, setGroupName] = useState();
  const [groupNameFirstWord, setGroupNameFirstWord] = useState();
  const [groupNameRestWords, setGroupNameRestWords] = useState();
  const [loading, setLoading] = useState(false);
  const [typeOfProduct, setTypeOfProduct] = useState([ 
    { isActive: false, name: 'Red wine', value: 'RED' },
    { isActive: false, name: 'White wine', value: 'WHITE' },
    { isActive: false, name: 'Prosseco', value: 'PROSSECO' },
    { isActive: false, name: 'Coctails', value: 'COCKTAILS' }
  ]);

  const [typeOfKegs, setTypeOfKegs] = useState([ 
    { isActive: false, name: 'Cocktails', value: 'COCKTAILS ON TAP' },
    { isActive: false, name: 'Wine', value: 'WINES ON TAP' },
  ]);

  const handleFilterClick = (index) => {
    const updatedTypeOfProduct = groupName?.includes("BOTTLES") ? [...typeOfProduct] : [...typeOfKegs];
    updatedTypeOfProduct[index].isActive = !updatedTypeOfProduct[index].isActive;
    groupName?.includes("BOTTLES") ? setTypeOfProduct(updatedTypeOfProduct) : setTypeOfKegs(updatedTypeOfProduct);
    filteredProduct(updatedTypeOfProduct);
  };

  const filteredProduct = (list) => {
    const activeFilter = list
      .filter(item => item.isActive)
      .map(item => item.value);

    const filteredList = !location?.pathname.includes("group/0") ?
      allProducts.filter(product => activeFilter.includes(product.typeOfProduct))
      :
      allProducts.filter(product => activeFilter.includes(product.productGroupName))

    setFilteredProducts(activeFilter.length ? filteredList : allProducts)
  }

  const resetFilters = () => {
    setTypeOfProduct(typeOfProduct.map((button) => ({ ...button, isActive: false })));
    setTypeOfKegs(typeOfKegs.map((button) => ({ ...button, isActive: false })))
    setFilteredProducts(allProducts);
  };

  const anyActiveFilters = typeOfProduct.some((button) => button.isActive) || typeOfKegs.some((button) => button.isActive);

  const getProductsFromGroup = async (id) => {
    setLoading(true);

    try {
      const productsResponse = await publicAPI.get(
        `/public/bacchus/product?product_group_id=${id}`
      );
      setAllProducts(productsResponse.data);    
      setFilteredProducts(productsResponse.data);

      const groupNameResponse = !location?.pathname.includes("group/0") && await publicAPI.get(
        `/public/bacchus/productgroup/${id}`
      );
      setGroupName(!location?.pathname.includes("group/0") ? groupNameResponse.data.name : 'kegs');
      !location?.pathname.includes("group/0") && setGroupNameFirstWord(
        groupNameResponse.data.name.substr(
          0,
          groupNameResponse.data.name.indexOf(" ")
        )
      );
      !location?.pathname.includes("group/0") && setGroupNameRestWords(
        groupNameResponse.data.name.substr(
          groupNameResponse.data.name.indexOf(" ")
        )
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProductsFromGroup(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      <Background>
        {mobileMenu ? <MobileMenu/> : <DesktopMenu/>}
        <TittleWrapper>
          <BackButton/>
          <AllProductsTitle>
            {groupName?.includes(" ") ? groupNameFirstWord : t(groupName)?.toUpperCase()}
            {groupName?.includes(" ") && <CreamTitle>{groupNameRestWords}</CreamTitle>}
          </AllProductsTitle>
        </TittleWrapper>
        {location?.pathname.includes("group/4") ? 
          <React.Fragment>
            <Text shop={true}>{t('veganCookie')}</Text>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '0 20px' }}>
              <Text top>{t('sustainableCookie')}</Text>
              <Text top>{t('beverageCookie')}</Text>
              <Text top>{t('noRecyclingNeeded')}</Text>
            </div>
          </React.Fragment>
            : <React.Fragment></React.Fragment>}
        {groupName?.includes("BOTTLES") ?
          <CategoryButtonWrapper>
            {typeOfProduct.map((button, index) => (
              <FilterButton
                key={button.name}
                active={button.isActive}
                onClick={() => handleFilterClick(index)}
              >
                {button.name}
              </FilterButton>
            ))}
          </CategoryButtonWrapper>
          :
          <React.Fragment></React.Fragment>
        }
        {location?.pathname.includes("group/0") ?
          <CategoryButtonWrapper>
            {typeOfKegs.map((button, index) => (
              <FilterButton
                key={button.name}
                active={button.isActive}
                onClick={() => handleFilterClick(index)}
              >
                {button.name}
              </FilterButton>
            ))}
          </CategoryButtonWrapper>
          :
          <React.Fragment></React.Fragment>
        }
        <FilterButtonWrapper>
          {anyActiveFilters && <FilterButton onClick={resetFilters}>Remove filters</FilterButton>}
        </FilterButtonWrapper>
        <AllProductsWrapper>
          <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
            {filteredProducts.length
              ? filteredProducts.map((item) => (
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={3}
                    key={`${item.id}_${item.name}`}
                  >
                    <SingleProduct
                      groupId={id}
                      item={item}
                    />
                  </Grid>
                ))
              : <AllProductsTitle style={{ textAlign: 'center', margin: '0 auto' }}>Currently we don't have product in that category</AllProductsTitle>}
          </Grid>
        </AllProductsWrapper>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default Products;
